import React from 'react'
import { VStack, Text, Link, Button, Heading, Container } from '@chakra-ui/react'

import { BooleanCheckbox, FormField, WizardStepForm } from 'components'

export const UserRegistrationStep1 = props => (
  <WizardStepForm {...props} hideNavigation justify='center'>
    <Heading size='4xl' textAlign='center' my={5}>
      Bem-vindo
    </Heading>
    <Container my={5}>
      <VStack spacing={5}>
        <Text fontSize='lg' align='center'>
          A Ferramenta de Avaliação de Risco inicia com o registo do Utilizador, da Entidade e do
          Projeto. Após o registo deve confirmar se pretende manter as ponderaçōes da AMA e
          responder às questoes colocadas.
        </Text>
        <FormField
          isRequired
          name='user.agree'
          defaultValue={false}
          render={
            <BooleanCheckbox size='lg' maxW='50ch' textAlign='center'>
              Aceito os <Link href='http://ia.tic.gov.pt/termos-e-condicoes' color="teal.500" isExternal>termos e condiçōes</Link> e a política de privacidade e segurança da Ferramenta de Avaliação de Risco
              produzida pela AMA
            </BooleanCheckbox>
          }
        />
        <Button size='lg' type='submit'>
          Iniciar Registo
        </Button>
      </VStack>
    </Container>
  </WizardStepForm>
)

export default UserRegistrationStep1
